// Modules
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

// Context
import { useAuthContext } from "~context/authContext"

// Constants
import PATHS from "~constants/paths"

// Custom Hooks
import usePrivatePath from "~hooks/usePrivatePath"

const Logout = () => {
  const navigate = useNavigate()

  // Get from context
  const { handleLogout } = useAuthContext()

  // Using custom hooks
  const loggedIn = usePrivatePath().isUserLoggedIn

  // Using effect to logout the user
  useEffect(() => {
    ;(async () => {
      if (loggedIn) {
        try {
          await handleLogout()
        } catch (e) {}
      }
      navigate(PATHS.login)
    })()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export default Logout
